"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _reactScrollToBottom = require("react-scroll-to-bottom");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ScrollToEndButton = _interopRequireDefault(require("./Activity/ScrollToEndButton"));

var _Speak = _interopRequireDefault(require("./Activity/Speak"));

var _useActivities3 = _interopRequireDefault(require("./hooks/useActivities"));

var _useGroupTimestamp3 = _interopRequireDefault(require("./hooks/useGroupTimestamp"));

var _useRenderActivity = _interopRequireDefault(require("./hooks/useRenderActivity"));

var _useRenderAttachment = _interopRequireDefault(require("./hooks/useRenderAttachment"));

var _useStyleOptions3 = _interopRequireDefault(require("./hooks/useStyleOptions"));

var _useStyleSet3 = _interopRequireDefault(require("./hooks/useStyleSet"));

var _useMemoArrayMap = _interopRequireDefault(require("./hooks/internal/useMemoArrayMap"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ROOT_CSS = (0, _glamor.css)({
  overflow: 'hidden',
  position: 'relative'
});
var PANEL_CSS = (0, _glamor.css)({
  display: 'flex',
  flexDirection: 'column',
  WebkitOverflowScrolling: 'touch'
});
var FILLER_CSS = (0, _glamor.css)({
  flex: 1
});
var LIST_CSS = (0, _glamor.css)({
  listStyleType: 'none',
  '& > li.hide-timestamp .transcript-timestamp': {
    display: 'none'
  }
});
var DEFAULT_GROUP_TIMESTAMP = 300000; // 5 minutes

function sameTimestampGroup(activityX, activityY, groupTimestamp) {
  if (groupTimestamp === false) {
    return true;
  } else if (activityX && activityY) {
    groupTimestamp = typeof groupTimestamp === 'number' ? groupTimestamp : DEFAULT_GROUP_TIMESTAMP;

    if (activityX.from.role === activityY.from.role) {
      var timeX = new Date(activityX.timestamp).getTime();
      var timeY = new Date(activityY.timestamp).getTime();
      return Math.abs(timeX - timeY) <= groupTimestamp;
    }
  }

  return false;
}

var BasicTranscript = function BasicTranscript(_ref) {
  var className = _ref.className;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      _useStyleSet2$ = _useStyleSet2[0],
      activitiesStyleSet = _useStyleSet2$.activities,
      activityStyleSet = _useStyleSet2$.activity;

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      hideScrollToEndButton = _useStyleOptions2[0].hideScrollToEndButton;

  var _useActivities = (0, _useActivities3.default)(),
      _useActivities2 = _slicedToArray(_useActivities, 1),
      activities = _useActivities2[0];

  var _useGroupTimestamp = (0, _useGroupTimestamp3.default)(),
      _useGroupTimestamp2 = _slicedToArray(_useGroupTimestamp, 1),
      groupTimestamp = _useGroupTimestamp2[0];

  var renderAttachment = (0, _useRenderAttachment.default)();
  var renderActivity = (0, _useRenderActivity.default)(renderAttachment);
  var renderActivityElement = (0, _react.useCallback)(function (activity) {
    var element = renderActivity({
      activity: activity,
      timestampClassName: 'transcript-timestamp'
    });
    return element && {
      activity: activity,
      element: element
    };
  }, [renderActivity]); // We use 2-pass approach for rendering activities, for show/hide timestamp grouping.
  // Until the activity pass thru middleware, we never know if it is going to show up.
  // After we know which activities will show up, we can compute which activity will show timestamps.
  // If the activity does not render, it will not be spoken if text-to-speech is enabled.

  var activityElements = (0, _useMemoArrayMap.default)(activities, renderActivityElement); // TODO: [P2] We can also use useMemoArrayMap() for this function.
  //       useMemoArrayMap(array, mapper) will need to be modified to useMemoArrayMap(array, mapper, getDeps).
  //       This is because the deps for every item is not itself anymore. It will include activityElements[index + 1].

  var trimmedActivityElements = activityElements.filter(function (activityElement) {
    return activityElement;
  });
  var activityElementsWithMetadata = (0, _react.useMemo)(function () {
    return trimmedActivityElements.filter(function (activityElement) {
      return activityElement;
    }).map(function (activityElement, index) {
      var activity = activityElement.activity;

      var _ref2 = trimmedActivityElements[index + 1] || {},
          nextActivity = _ref2.activity;

      return _objectSpread({}, activityElement, {
        key: activity.channelData && activity.channelData.clientActivityID || activity.id || index,
        // TODO: [P2] We should use core/definitions/speakingActivity for this predicate instead
        shouldSpeak: activity.channelData && activity.channelData.speak,
        // Hide timestamp if same timestamp group with the next activity
        timestampVisible: !sameTimestampGroup(activity, nextActivity, groupTimestamp)
      });
    });
  }, [groupTimestamp, trimmedActivityElements]);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(ROOT_CSS + '', className + ''),
    role: "log"
  }, _react.default.createElement(_reactScrollToBottom.Panel, {
    className: PANEL_CSS + ''
  }, _react.default.createElement("div", {
    className: FILLER_CSS
  }), _react.default.createElement("ul", {
    "aria-atomic": "false",
    "aria-live": "polite",
    "aria-relevant": "additions text",
    className: (0, _classnames.default)(LIST_CSS + '', activitiesStyleSet + ''),
    role: "list"
  }, activityElementsWithMetadata.map(function (_ref3) {
    var activity = _ref3.activity,
        element = _ref3.element,
        key = _ref3.key,
        timestampVisible = _ref3.timestampVisible,
        shouldSpeak = _ref3.shouldSpeak;
    return _react.default.createElement("li", {
      // Because of differences in browser implementations, aria-label=" " is used to make the screen reader not repeat the same text multiple times in Chrome v75 and Edge 44
      "aria-label": " ",
      className: (0, _classnames.default)(activityStyleSet + '', {
        // Hide timestamp if same timestamp group with the next activity
        'hide-timestamp': !timestampVisible
      }),
      key: key,
      role: "listitem"
    }, element, shouldSpeak && _react.default.createElement(_Speak.default, {
      activity: activity
    }));
  }))), !hideScrollToEndButton && _react.default.createElement(_ScrollToEndButton.default, null));
};

BasicTranscript.defaultProps = {
  className: ''
};
BasicTranscript.propTypes = {
  className: _propTypes.default.string
};
var _default = BasicTranscript;
exports.default = _default;